<template>
  <div class="row">
    <div class="col-8">
      <card>
        <template slot="header">
          <h4 class="card-title">
            {{cardTitle}}

            <div class="btn-group pull-right" v-if="edit">
              <button class="btn btn-success" @click="save">
                <font-awesome-icon icon="save"></font-awesome-icon>
                Save
              </button>
              <button class="btn btn-danger" @click="toggleEdit(false)">
                <font-awesome-icon icon="times"></font-awesome-icon>
                Cancel
              </button>
            </div>
            <div class="btn-group pull-right" v-else>
              <button class="btn btn-warning" @click="toggleEdit(true)">
                <font-awesome-icon icon="edit"></font-awesome-icon>
                Edit
              </button>
            </div>
          </h4>
        </template>
        <div class="row">
          <div class="col-8">
            <fg-input label="Username"
                      type="text"
                      :required="true"
                      v-model="user.username"
                      :disabled="!edit"/>
            <fg-input label="Password"
                      type="password"
                      v-if="isAddMode"
                      :required="true"
                      v-model="user.password"
                      :disabled="!edit"/>
            <fg-input label="First Name"
                      type="text"
                      :required="true"
                      v-model="user.firstName"
                      :disabled="!edit"/>
            <fg-input label="Last Name"
                      type="text"
                      :required="true"
                      v-model="user.lastName"
                      :disabled="!edit"/>
            <fg-input label="Email"
                      type="email"
                      :required="true"
                      v-model="user.email"
                      :disabled="!edit"/>
          </div>
          <div class="col-4">
            <l-checkbox v-model="user.isAdmin" :disabled="!edit">
              Is Admin
            </l-checkbox>
            <fg-input label="Created"
                      type="text"
                      input-classes="form-control-plaintext"
                      :value="getDate(user.createdAt)"/>
            <fg-input label="Last update"
                      type="text"
                      input-classes="form-control-plaintext"
                      :value="getDate(user.updatedAt)"/>
          </div>
        </div>
      </card>
    </div>
    <div class="col-4" v-if="!isAddMode">
      <card title="Password change">
        <p>To change the password of an account fill the new password below or use the button below
          to generate a new random password.</p>
        <fg-input label="Password"
                  type="password"
                  v-model="user.password"
                  :disabled="!edit"/>
      </card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LCheckbox from "../../../components/Inputs/Checkbox.vue";

export default {
  name: "UserInfo",
  components: {
    LCheckbox,
  },
  props: {
    id: String,
    edit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardTitlePrefix() {
      if (!this.edit) {
        return "Viewing information for:";
      }

      return this.isAddMode
        ? "Adding new record:"
        : "Editing information for:";
    },
    cardTitle() {
      return `${this.cardTitlePrefix} ${this.user.fullName}`;
    },
    isAddMode() {
      return this.id === null || this.id === undefined || this.id === "";
    },
    url() {
      return `/entity/users/${this.id}`;
    },
  },
  data() {
    return {
      user: {
        fullName: "",
        username: "",
        password: "",
        firstName: "",
        lastName: "",
        email: "",
        isAdmin: false,
        createdAt: new Date(),
        updatedAt: new Date(),
      }
    };
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    },
    async refreshData() {
      const response = await this.axios.get(this.url);
      this.user = response.data;
    },
    toggleEdit(inEdit) {
      if (!inEdit && this.isAddMode) {
        this.$router.back();
        return;
      }

      const query = {};
      if (inEdit) {
        query.edit = true;
      }
      this.$router.replace({
        path: this.$route.path,
        query
      });
      if (!inEdit) {
        this.refreshData();
      }
    },
    async save() {
      try {
        let method = "put";
        const localUser = Object.assign(this.user);

        if (this.isAddMode) {
          method = "post";
          localUser.confirmPassword = localUser.password;
        } else if (localUser.password === "") {
          delete localUser.password;
        } else {
          localUser.confirmPassword = localUser.password;
        }

        await this.axios[method](this.url, {
          user: this.user
        });
        this.$notify({
          message: "Data saved"
        });
        this.toggleEdit(false);
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.message
        });
      }
    }
  },
  beforeMount() {
    if (!this.isAddMode) {
      this.refreshData();
    }
  }
};
</script>

<style scoped>

</style>
